import { isEmpty } from 'lodash-es'
import { ElMessage } from 'element-plus'
import { StatusCodes } from 'http-status-codes'

import router from '@/router'
import { useCommonStore } from '@/store/useCommonStore'
import { i18n, LOCALE_KEYS } from '@/locale'
import { LOCALSTORAGE_KEYS } from '@/static/enums'
import { isUploadingFileInFormData } from './common'
import generateRequest, { generatorAPIS as G } from './request'
import { paths } from '@/router/paths'

const TIMEOUT = {
  DEFAULT: 60000,
  UPLOADING: 5 * 60000,
}

const ERROR_CODES = {
  REPEAT_LOGIN: '510',
  CASE_NO_OPERATION: '3005',
}

const uploadAPIs = ['static-files']

const ignoreRolesUrls = ['/api/shieldBff/department/department-role']

const ignoreGONEUrls = ['/api/openid/logout']

export const request = generateRequest({
  timeout: TIMEOUT.DEFAULT,
  withCredentials: true,
  requestInterceptors: [
    (config) => {
      const { url, data } = config
      const commonStore = useCommonStore()
      const { locale } = commonStore

      return {
        ...config,
        timeout:
          uploadAPIs.some((item) => (url as string).includes(item)) &&
          isUploadingFileInFormData(data)
            ? TIMEOUT.UPLOADING
            : config.timeout,
        headers: {
          ...config.headers,
          ...(ignoreRolesUrls.includes(url as string)
            ? {}
            : {
                ROLE: localStorage.getItem(LOCALSTORAGE_KEYS.ROLE) || '', // role,
              }),

          locale,
        },
      }
    },
    (error: any) => Promise.reject(error),
  ],
  responseInterceptors: [
    (response: any) => {
      const commonStore = useCommonStore()
      const { data, status, config } = response

      if (status === StatusCodes.OK) {
        const { exceptionInfo, code } = data
        const {
          messageEn = '',
          messageCn = '',
          exceptionCode = '',
        } = !isEmpty(exceptionInfo) ? exceptionInfo : {}
        const message = commonStore.locale === LOCALE_KEYS.CN ? messageCn : messageEn

        if (typeof code === 'undefined' && data instanceof Blob) return response
        if (code !== StatusCodes.OK) {
          if (message) ElMessage.error(message)
          if (code === StatusCodes.GONE) {
            let token
            try {
              token = localStorage.getItem(LOCALSTORAGE_KEYS.TOKEN)
            } catch (error) {
              token = null
            }

            if (token && !ignoreGONEUrls.includes(config.url))
              ElMessage.error(i18n.global.t('common.410'))

            localStorage.setItem(LOCALSTORAGE_KEYS.REDIRECT, window.location.href)
            localStorage.removeItem(LOCALSTORAGE_KEYS.TOKEN)
            window.location.href = data.data
          }
          if (exceptionCode === ERROR_CODES.CASE_NO_OPERATION) window.location.href = `#/403`
          return Promise.reject(response)
        }

        return response
      }
      return Promise.reject(response)
    },
    (error) => {
      const { response } = error
      const { status } = response
      if (status === StatusCodes.UNAUTHORIZED) {
        ElMessage.error(i18n.global.t('common.401'))
        router.replace({ path: paths.home })
      } else ElMessage.error(error?.message as string)
      return Promise.reject(error)
    },
  ],
  authorizationToken: LOCALSTORAGE_KEYS.TOKEN,
})

export const generatorAPIS = <T extends string>(apiConfig: Record<string, string>) =>
  G<T>(request, apiConfig)
